export default class SearchPhysicianModel {
    lastName: string
    dateOfBirth: string
    ssn4: string
    siteToken: string
}

export class MatchPhysicianResult {
    requiresAccountAssistance: boolean;
    isExactMatch: boolean;
}